// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    height: 25vh;
    background-color: #042C22;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.footer-text {
    color: #fff;
    opacity: 0.5;
    text-align: center;
    font-weight: 300;
    width: 100%;
}

.footer-links {
    display: flex;
}

.footer-links p a {
    color: #fff;
}

.footer-links p {
    margin: 0 10px;
    width: max-content;
    cursor: pointer;
    color: #fff;
    text-decoration: underline;
}

.footer-links p:hover {
    text-decoration: underline;
}

@media screen and (min-width: 768px) {
    s .footer-text {
        width: 40%;
    }
}

body {
    background-color: #f2f7fb
}

.login-block {
    /* margin: 30px auto; */
    width: 500px;
    max-height: 400px;
    /* min-height: 93.6vh */
}

.login-block .auth-box {
    /* margin: 20px auto 0; */
    max-width: 569px !important
}

.contact-us {
    font-size: 24px;
    font-weight: 300
}

.respond {
    font-size: 15px !important;
    font-weight: 200;
    margin-top: -6px
}

.card {
    border-radius: 5px;
    box-shadow: 0 0 5px 0 rgba(43, 43, 43, .1), 0 11px 6px -7px rgba(43, 43, 43, .1);
    border: none;
    margin-bottom: 30px;
    transition: all .3s ease-in-out
}

.card .card-block {
    padding: 1.25rem
}

.f-56 {
    font-size: 56px
}

.form-group {
    margin-bottom: 1.25em
}

.form-material .form-control {
    display: inline-block;
    height: 43px;
    width: 100%;
    border: none;
    border-radius: 0;
    font-size: 16px;
    font-weight: 400;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border-bottom: 1px solid #ccc
}

.btn-md {
    padding: 10px 16px;
    font-size: 15px;
    line-height: 23px
}

.btn-primary {
    background-color: #00a378;
    border-radius: 15px;
    color: #fff;
    outline: none;
    box-shadow: none;
    border: none;
    cursor: pointer;
    transition: all ease-in .3s
}

.btn {
    border-radius: 2px;
    text-transform: capitalize;
    font-size: 15px;
    padding: 10px 19px;
    cursor: pointer
}

.m-b-20 {
    margin-bottom: 20px
}

.btn-md {
    padding: 10px 16px;
    font-size: 15px;
    line-height: 23px
}

.contactClose {
    cursor: pointer;
    float: right;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAElB,gFAAgF;IAChF,YAAY;IACZ,mBAAmB;IAEnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,6BAA6B;IAE7B,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IAEf;AACJ;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".footer {\n    height: 25vh;\n    background-color: #042C22;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.footer-text {\n    color: #fff;\n    opacity: 0.5;\n    text-align: center;\n    font-weight: 300;\n    width: 100%;\n}\n\n.footer-links {\n    display: flex;\n}\n\n.footer-links p a {\n    color: #fff;\n}\n\n.footer-links p {\n    margin: 0 10px;\n    width: max-content;\n    cursor: pointer;\n    color: #fff;\n    text-decoration: underline;\n}\n\n.footer-links p:hover {\n    text-decoration: underline;\n}\n\n@media screen and (min-width: 768px) {\n    s .footer-text {\n        width: 40%;\n    }\n}\n\nbody {\n    background-color: #f2f7fb\n}\n\n.login-block {\n    /* margin: 30px auto; */\n    width: 500px;\n    max-height: 400px;\n    /* min-height: 93.6vh */\n}\n\n.login-block .auth-box {\n    /* margin: 20px auto 0; */\n    max-width: 569px !important\n}\n\n.contact-us {\n    font-size: 24px;\n    font-weight: 300\n}\n\n.respond {\n    font-size: 15px !important;\n    font-weight: 200;\n    margin-top: -6px\n}\n\n.card {\n    border-radius: 5px;\n    -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, .1), 0 11px 6px -7px rgba(43, 43, 43, .1);\n    box-shadow: 0 0 5px 0 rgba(43, 43, 43, .1), 0 11px 6px -7px rgba(43, 43, 43, .1);\n    border: none;\n    margin-bottom: 30px;\n    -webkit-transition: all .3s ease-in-out;\n    transition: all .3s ease-in-out\n}\n\n.card .card-block {\n    padding: 1.25rem\n}\n\n.f-56 {\n    font-size: 56px\n}\n\n.form-group {\n    margin-bottom: 1.25em\n}\n\n.form-material .form-control {\n    display: inline-block;\n    height: 43px;\n    width: 100%;\n    border: none;\n    border-radius: 0;\n    font-size: 16px;\n    font-weight: 400;\n    padding: 0;\n    background-color: transparent;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    border-bottom: 1px solid #ccc\n}\n\n.btn-md {\n    padding: 10px 16px;\n    font-size: 15px;\n    line-height: 23px\n}\n\n.btn-primary {\n    background-color: #00a378;\n    border-radius: 15px;\n    color: #fff;\n    outline: none;\n    box-shadow: none;\n    border: none;\n    cursor: pointer;\n    -webkit-transition: all ease-in .3s;\n    transition: all ease-in .3s\n}\n\n.btn {\n    border-radius: 2px;\n    text-transform: capitalize;\n    font-size: 15px;\n    padding: 10px 19px;\n    cursor: pointer\n}\n\n.m-b-20 {\n    margin-bottom: 20px\n}\n\n.btn-md {\n    padding: 10px 16px;\n    font-size: 15px;\n    line-height: 23px\n}\n\n.contactClose {\n    cursor: pointer;\n    float: right;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
